import { partialRight as _partialRight } from 'es-toolkit/compat';

export const parseInteger: (target: string) => number = _partialRight(parseInt, 10);
export const copyToClipboard = (element: HTMLInputElement) => {
  element.select();
  document.execCommand('copy');
};
